<template>
  <div class="tile is-ancestor">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <label class="label">
          Шаблон сценария
        </label>
        <div class="select is-primary">
          <select v-model="currentScenario" class="form-control" v-bind:disabled="loadedScenario !== null">
            <option v-for="scenario in activeSelectList">
              {{scenario.name}}
            </option>
          </select>
        </div>
        <scenario-question-recognition v-if="currentScenario === selectList[0].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-question-recognition>
        <scenario-question-yes-no v-if="currentScenario === selectList[1].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-question-yes-no>
        <scenario-two-level-yes-no v-if="currentScenario === selectList[2].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-two-level-yes-no>
        <scenario-notice v-if="currentScenario === selectList[3].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-notice>
        <scenario-question-interview v-if="currentScenario === selectList[4].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-question-interview>
      </article>
    </div>

  </div>
</template>

<script>
  import ScenarioQuestionRecognition from './ScenarioQuestionRecognition'
  import ScenarioQuestionYesNo from './ScenarioQuestionYesNo'
  import ScenarioTwoLevelYesNo from './ScenarioTwoLevelYesNo'
  import ScenarioQuestionInterview from './ScenarioQuestionInterview'
  import ScenarioInterviewAFewQuestions from './ScenarioInterviewAFewQuestions'
  import ScenarioNotice from './ScenarioNotice'
  import { mapGetters, mapMutations } from 'vuex'
  import Vue from 'vue'
  import CheckToken from '../authentication/CheckToken'
  // import {loadedScenario} from "../../store/getters";

  Vue.mixin(CheckToken)

  const api = '/api/scenarios'
  const APPCONFIG_API = '/api/appConfig'

  export default {
    props: ['campaignid', 'id'],

    computed: {
      ...mapGetters([
        'authenticationToken'
      ])
    },
    methods: {
      ...mapMutations([
        'setLoadedScenario'
      ]),
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadAppConfig () {
        this.$http.get(APPCONFIG_API + '/templates', {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.templates = response.data
            for (var i = 0; i < this.selectList.length; i++) {
              if (this.templates[this.selectList[i].name]) {
                  this.activeSelectList.push(this.selectList[i])
              }
            }
            this.currentScenario = this.activeSelectList[0].name
            this.loadedScenario = this.loadScenario()
            console.log('loadedScenario ' + this.loadedScenario)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
          })
      },
      loadScenario() {
        if (this.$props.id) {
          this.$http.get(`${api}/${this.$props.id}`, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              this.setLoadedScenario(response.data)
              this.currentScenario = response.data.template
              this.setLoadedScenario(response.data)
              return response.data
            })
            .catch((error) => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка загрузки сценария. ')
            })
        } else {
          this.setLoadedScenario(null)
          return null
        }
      },
      setScenario(value) {
        this.loadedScenario = value
      }
    },
    components: {
      ScenarioQuestionRecognition,
      ScenarioQuestionYesNo,
      ScenarioTwoLevelYesNo,
      ScenarioQuestionInterview,
      ScenarioNotice,
      ScenarioInterviewAFewQuestions
    },
    created: function () {
      this.checkToken()
      // this.currentScenario = this.selectList[0].name
      if (!this.$props.id) {
        console.log('creating new scenario')
        this.appconfig = this.loadAppConfig()
      } else {
        console.log('loading scenario: ' + this.name)
        this.appconfig = this.loadAppConfig()
      }
    },
    data() {
      return {
        currentScenario: '',
        selectList: [
          {
            id: 1,
            name: 'recognition',
          },
          {
            id: 2,
            name: 'yesnoonequestion'
          },
          {
            id: 3,
            name: 'yesnotwoquestions'
          },
          {
            id: 4,
            name: 'notification'
          },
          {
            id: 5,
            name: 'poll'
          }
        ],
        activeSelectList: [],
        loadedScenario: null,
        templates: {
         name: '',
         active: false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Scenario.vue?266d8d8c